import PropTypes from "prop-types";

function NotificationIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12">
      <g fill="#eb8559" stroke="#454546" strokeWidth="0.57">
        <circle cx="6" cy="6" r="6" stroke="none" />
        <circle cx="6" cy="6" r="5.715" fill="none" />
      </g>
      <text
        fill="#fff"
        fontSize="9"
        fontFamily="Helvetica-Bold, Helvetica"
        fontWeight="700"
        textAnchor="middle"
        dominantBaseline="middle"
        x="50%"
        y="60%"
      >
        1
      </text>
    </svg>
  );
}

NotificationIcon.propTypes = {
  size: PropTypes.number,
};

export default NotificationIcon;
